const s = {
  name: "Photos",
  dimensions: { width: 40, height: 32 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 32" style="enable-background:new 0 0 40 32;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M33,10c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.7,0,3-1.3,3-3S34.7,10,33,10z M32,13c0-0.6,0.4-1,1-1c0.6,0,1,0.4,1,1
			c0,0.6-0.4,1-1,1C32.4,14,32,13.6,32,13z"/>
		<path class="st0" d="M11,19c0-5,4-9,9-9c5,0,9,4,9,9s-4,9-9,9C15,28,11,24,11,19z M20,12c-3.9,0-7,3.1-7,7s3.1,7,7,7s7-3.1,7-7
			S23.9,12,20,12z"/>
		<path class="st0" d="M11.6,2.1C12,0.8,13.2,0,14.4,0h11.1c1.3,0,2.4,0.8,2.8,2.1l0,0L29.7,6H37c1.7,0,3,1.3,3,3v20
			c0,1.7-1.3,3-3,3H3c-1.7,0-3-1.3-3-3V9c0-1.7,1.3-3,3-3h7.3L11.6,2.1L11.6,2.1z M14.4,2c-0.4,0-0.8,0.3-1,0.7l0,0L11.7,8H3
			C2.5,8,2,8.5,2,9v20c0,0.5,0.5,1,1,1h34c0.5,0,1-0.5,1-1V9c0-0.5-0.5-1-1-1h-8.7l-1.8-5.3l0,0C26.4,2.3,26,2,25.6,2H14.4z"/>
		<path class="st0" d="M9,4H2V2h7V4z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Photos
};
